module.exports = [{
      plugin: require('../node_modules/gatsby-plugin-manifest/gatsby-browser.js'),
      options: {"plugins":[],"name":"Shpock","short_name":"Shpock","start_url":"/","background_color":"#3cce69","theme_color":"#3cce69","display":"standalone","icon":"src/images/Icon.png","legacy":true,"theme_color_in_head":true,"cache_busting_mode":"query","crossOrigin":"anonymous","include_favicon":true,"cacheDigest":"78a1d2d318c60939bccfffcb2c523ca1"},
    },{
      plugin: require('../gatsby-browser.js'),
      options: {"plugins":[]},
    }]
